import forEach from "lodash/forEach";
export function groupByMultipleCategories(categories, offerCatalog) {
  const result = {};
  // Iterate over input categories
  categories.forEach((category) => {
    // Filter the offerCatalog items that match the current category
    const matchingItems = offerCatalog.filter((item) =>
      item.categories.some((cat) => cat.category_id === category.id),
    );
    // console.log(category.category);
    if (matchingItems.length > 0) {
      // console.log(matchingItems);
      // Add matched items to the result under the appropriate category
      result[category.category] = matchingItems;
    }
  });
  return result;
}

export function getProductsByCategory(
  categories,
  offerCatalog,
  favouritesTranslated,
  otherTranslated,
  existingStructure = null
) {
  const result = existingStructure || {};
  
  categories.forEach((category) => {
    const categoryName = category.category;
    if (!result[categoryName]) {
      result[categoryName] = {};
    }
    
    const subCategoryName = category.subcategory || '';
    if (!result[categoryName][subCategoryName]) {
      result[categoryName][subCategoryName] = [];
    }
  });

  if (!result[favouritesTranslated]) {
    result[favouritesTranslated] = {};
  }

  if (offerCatalog && offerCatalog.length > 0) {
    offerCatalog.forEach((product) => {
      product.categories.forEach((productCategory) => {
        const mainCategory = productCategory.category || otherTranslated;
        const subCategory = productCategory.subcategory || '';
        
        if (!result[mainCategory]) {
          result[mainCategory] = {};
        }
        
        if (!result[mainCategory][subCategory]) {
          result[mainCategory][subCategory] = [];
        }
        
        if (!result[mainCategory][subCategory].some(item => item.id === product.id)) {
          result[mainCategory][subCategory].push(product);
        }
      });
    });

    const uniqueFavouriteItems = offerCatalog.reduce(
      (acc, item) => {
        if (item.is_favourite && !acc.set.has(item.id)) {
          acc.set.add(item.id);
          acc.items.push(item);
        }
        return acc;
      },
      { set: new Set(), items: [] }
    ).items;

    uniqueFavouriteItems.forEach((item) => {
      const firstCategory = item.categories[0]?.category || otherTranslated;
      if (!result[favouritesTranslated][firstCategory]) {
        result[favouritesTranslated][firstCategory] = [];
      }
      result[favouritesTranslated][firstCategory].push(item);
    });
  }

  return result;
}

export function groupBySubcategory(
  productsByCategory,
  favouritesTranslated,
  allTranslated,
) {
  forEach(productsByCategory, (products, name) => {

    if (name === favouritesTranslated) return;

    if (typeof products !== 'object' || products === null) {
      productsByCategory[name] = {};
      return;
    }

    const subcategories = Object.keys(products);
    
    if (subcategories.length > 1 && products['']) {
      const allProducts = products[''];
      delete productsByCategory[name][''];
      
      const newSubcategories = {
        [allTranslated]: allProducts
      };
      Object.keys(products).sort().forEach(key => {
        if (key !== '') {
          newSubcategories[key] = products[key];
        }
      });
      productsByCategory[name] = newSubcategories;
    }
    
    else if (subcategories.length === 1 && subcategories[0] === '') {
      
      const firstProduct = products[''][0];
      if (firstProduct && firstProduct.categories) {
        const categoryData = firstProduct.categories.find(cat => cat.category === name);
        if (categoryData && categoryData.subcategory) {
         
          productsByCategory[name][categoryData.subcategory] = products[''];
          delete productsByCategory[name][''];
        } else {
          
          productsByCategory[name][allTranslated] = products[''];
          delete productsByCategory[name][''];
        }
      }
    }
  });

  return productsByCategory;
}
